import React from 'react'

import "./css/table.css"

function ResultTable(props) {
    const { lastday } = props;
    return (
        <table className="table table-responsive table-bordered text-center">
            <thead>
                <tr>
                    <th rowspan={2}></th>
                    <th rowspan={2}>จำนวนระบบ</th>
                    <th colSpan={3}>สถานะระบบ</th>
                    <th rowspan={2}>วันที่ไม่สามารถบริการได้</th>
                    <th rowspan={2}>ระยะเวลาที่ไม่สามารถบริการได้</th>
                </tr><tr>
                    <th>กำลังดำเนินการ</th>
                    <th>ดำเนินการเสร็จเรียบร้อย</th>
                    <th>วันที่</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>พร้อมใช้งาน</td>
                    <td>6</td>
                    <td>-</td>
                    <td>&#10004;</td>
                    <td>1-{lastday}</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>มีเหตุการณ์ผิดปรกติ</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>บริการขัดข้อง</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            </tbody>
        </table>
    )
}

export default ResultTable